(function() {
    angular.module('tmx-app')
        .controller('processInstanceEditCtrl', ['$scope', 'resolvedData', 'lookupService', '$state','ToastService', 

            function CustomersEditCtrl($scope, resolvedData, lookupService, $state, ToastService) {
                var customerVM = this;
                customerVM.vm = resolvedData.Customer.data;
                customerVM.isEdit=false;

    ///////////////////FUNCTIONS////////////////////////

                customerVM.addPhoneField=function(){
                    if(!angular.isDefined(customerVM.phoneNumberCount))
                        customerVM.phoneNumberCount=1;
                    customerVM.phoneNumberFields.push({
                        type:1,
                        number:null,
                        ext:null
                    });
                    customerVM.phoneNumberCount++;
                }
                customerVM.formatPhoneNumber=function(PhoneNumber1){
                    if(angular.isDefined(PhoneNumber1) && PhoneNumber1!=null) {
                        var country = PhoneNumber1.slice(0,2);
                        var city = PhoneNumber1.slice(2,5);
                        var number = PhoneNumber1.slice(5);
                        number = number.slice(0, 3) + '-' + number.slice(3,7);
                        return "+"+country+" (" +city+") "+number;
                    }
                    return "N/A";
                }
    
  ////////////////////////////////DATE START VALIDATION//////////////////////////////////////////////////////////////////
                customerVM.onStartDateSelected = function(selectedDate) {
                    if(selectedDate!=null) {
                        customerVM.vm.EffectiveStartDate = selectedDate.toJSON();//start Date
                        customerVM.StartDateInvalid = false;
                        customerVM.minEndDate = customerVM.vm.EffectiveStartDate;//ensuring that end date >= start Date

               //calling validation function passing in strings
                        $scope.checkEndDate();

                    }
                    else{
                        customerVM.StartDateInvalid = true;
                    }
                };
 ////////////////////////////////DATE START VALIDATION//////////////////////////////////////////////////////////////////
                $scope.checkEndDate = function(){

                    if(angular.isDefined(customerVM.vm)){


                        var StartDate = new Date(customerVM.vm.EffectiveStartDate);//forming a date object from JSON string
                        var StartDateString = StartDate.toDateString();//getting the date out of the whole date-time
                        var StartDateNew = new Date(StartDateString);//converting the new string to date object

                        var EndDate = new Date(customerVM.vm.EffectiveEndDate);
                        var EndDateString = EndDate.toDateString();
                        var EndDateNew = new Date(EndDateString);//converting the new string to date object


                        if(customerVM.vm.EffectiveEndDate == undefined ||
                    customerVM.vm.EffectiveEndDate == null ||
                    StartDateNew > EndDateNew){
                            return true;
                        }
                        else{
                            return false;
                        }
                    }
                };
////////////////////////////////DATE START VALIDATION//////////////////////////////////////////////////////////////////
                customerVM.onEndDateSelected = function(selectedDate) {
                    if(selectedDate != null ) {

                        customerVM.vm.EffectiveEndDate = selectedDate.toJSON();//end Date
                        customerVM.EndDateInvalid = false;
                    }
                    else{
                        customerVM.EndDateInvalid = true;

                    }
                };
                customerVM.onExpiryDateSelected = function(selectedDate) {
                    if(selectedDate != null ) {

                        customerVM.vm.NationalIdentifierExpDate = selectedDate.toJSON();//end Date
                // customerVM.EndDateInvalid = false;
                    }
                    else{
                // customerVM.EndDateInvalid = true;

                    }
                };
                customerVM.onBirthDateSelected = function(selectedDate) {
                    if(selectedDate != null ) {

                        customerVM.vm.TmxCustomerHousehold[0].DateOfBirth = selectedDate.toJSON();//end Date
                // customerVM.EndDateInvalid = false;
                    }
                    else{
                // customerVM.EndDateInvalid = true;

                    }
                };
                customerVM.getStatus = function() {
                    if (angular.isDefined(customerVM.vm.EffectiveEndDate) && angular.isDefined(customerVM.vm.EffectiveStartDate)) {
                        if (customerVM.vm.EffectiveEndDate > customerVM.date && customerVM.vm.EffectiveStartDate < customerVM.date) {
                            return "Active";
                        }
                    }
                    return "Inactive";
                }
                customerVM.save = function(action,form) {
                    var dirtyFormControls = [];
                    customerVM.formSubmitted = true;
                    if (form.$invalid) {
                        customerVM.error_msg = "";
                        angular.forEach(form, function(value) {
                            if (typeof value === 'object' && value.hasOwnProperty('$modelValue') && value.$invalid) {
                                dirtyFormControls.push(value.$name)
                                value.$touched=true;                      
                            }
                        });
                        customerVM.error_msg = "These fields are required: "
                        for (var i = 0; i < dirtyFormControls.length; i++) {
                            if(i==dirtyFormControls.length-1) {
                                customerVM.error_msg += " and " + dirtyFormControls[i];
                            }
                            else
                                customerVM.error_msg +=  dirtyFormControls[i] + ", ";
                        }
         // ToastService.showCustomToast("error",customerVM.error_msg);
                    }
                    else{
      // customerVM.loading=true;
                        if(angular.isDefined(customerVM.vm.TmxCustomerHousehold[0].TmXCustomerAddressMapping[0].TmxAddress) && angular.isDefined(customerVM.vm.TmxCustomerHousehold[0].TmXCustomerAddressMapping[0].TmxAddress.TmXAddressGeography)) {
                            customerVM.vm.TmxCustomerHousehold[0].TmXCustomerAddressMapping[0].TmxAddress.TmXAddressGeography = undefined;
                        }
      // if(!angular.isDefined(customerVM.vm.CustomerName))
      // {
                        customerVM.vm.CustomerName = customerVM.vm.TmxCustomerHousehold[0].FirstName + " " + customerVM.vm.TmxCustomerHousehold[0].MiddleName + " " + customerVM.vm.TmxCustomerHousehold[0].LastName; 
                        customerVM.vm.CustomerCode = "TEST";
      // }
                        customerVM.loading=true;

                        customerVM.CustomerAddressMapping=[];
                        customerVM.CustomerHousehold=[];

                        var Address={
                            CustomerAddressTypeLkp:customerVM.vm.TmxCustomerHousehold[0].TmXCustomerAddressMapping[0].CustomerAddressTypeLkp,
                            TmxAddress:customerVM.vm.TmxCustomerHousehold[0].TmXCustomerAddressMapping[0].TmxAddress
                        };

                        customerVM.vm.TmxCustomerHousehold[0].TmXCustomerAddressMapping.push(Address);
                        var NewcustomerHousehold=customerVM.vm.TmxCustomerHousehold[0];


                        customerVM.CustomerHousehold.push(NewcustomerHousehold);
                        customerVM.vm.TmxCustomerHousehold=customerVM.CustomerHousehold;

      //if(angular.isDefined(customerVM.vm.TmxAddress) && angular.isDefined(customerVM.vm.TmxAddress.TmXAddressGeography))
      //{
      //  customerVM.vm.TmxAddress.TmXAddressGeography = undefined;
      //}
                        if (!angular.isDefined(customerVM.vm.UserName))
                            customerVM.vm.UserName = customerVM.vm.EmailAddress;


                        customerVM.vm.$saveOrUpdate().then(function(promise) {
                            if(angular.isDefined($state.data.grid.customerGrid)) $state.data.grid.customerGrid.dataSource.read();
                            if(angular.isDefined(promise)) {
                                if(action=="save") {
                                    $state.go("^");
                                }
                                else if(action=="saveandnew") {
                                    $state.reload($state.current);
                                }
                            }
                            else
                                ToastService.showCustomToast("error","Some Error Occured");
                        });
                    }
                };
  //   customerVM.saveAndNew = function() {
  //     customerVM.loading=true;

  //     //customerVM.CustomerAddressMapping=[];
  //     //customerVM.CustomerHousehold=[];

  //     //var Address={
  //     //  CustomerAddressTypeLkp:customerVM.vm.TmxCustomerHousehold[0].TmXCustomerAddressMapping[0].CustomerAddressTypeLkp,
  //     //  TmxAddress:customerVM.vm.TmxCustomerHousehold[0].TmXCustomerAddressMapping[0].TmxAddress
  //     //};

  //     //customerVM.vm.TmxCustomerHousehold[0].TmXCustomerAddressMapping = Address;
  //     //var NewcustomerHousehold=customerVM.vm.TmxCustomerHousehold[0];


  // //NewcustomerHousehold.TmxCustomerHousehold.TmxCustomerAddressMapping = Address;

  //     //customerVM.vm.CustomerAddressMapping.push(Address);
  //     //customerVM.CustomerHousehold.push(NewcustomerHousehold);
  //     //customerVM.vm.TmxCustomerHousehold=customerVM.CustomerHousehold;

  //     //if(angular.isDefined(customerVM.vm.TmxAddress) && angular.isDefined(customerVM.vm.TmxAddress.TmXAddressGeography))
  //     //{
  //     //  customerVM.vm.TmxAddress.TmXAddressGeography = undefined;
  //     //}
  //     customerVM.CustomerAddressMapping=[];
  //     customerVM.CustomerHousehold=[];

  //     var Address={
  //       CustomerAddressTypeLkp:customerVM.vm.TmxCustomerHousehold[0].TmXCustomerAddressMapping[0].CustomerAddressTypeLkp,
  //       TmxAddress:customerVM.vm.TmxCustomerHousehold[0].TmXCustomerAddressMapping[0].TmxAddress
  //     };
  //     customerVM.CustomerAddressMapping.push(Address);
  //     customerVM.vm.TmxCustomerHousehold[0].TmXCustomerAddressMapping=customerVM.CustomerAddressMapping;
  //     var NewcustomerHousehold=customerVM.vm.TmxCustomerHousehold[0];


  //     customerVM.CustomerHousehold.push(NewcustomerHousehold);
  //     customerVM.vm.TmxCustomerHousehold=customerVM.CustomerHousehold;
  //     if (!angular.isDefined(customerVM.vm.UserName))
  //       customerVM.vm.UserName = customerVM.vm.EmailAddress;


  //     customerVM.vm.$saveOrUpdate().then(function(promise) {
  //       // $state.data.grid.userGrid.dataSource.read();
  //       customerVM.loading=false;
  //       $state.go("^.add");
  //     });
  //   };
                customerVM.cancel = function() {
                    $state.go("^");
                };
                customerVM.statusChange = function() {
                };


    //////////////////////CODE//////////////////////////
                customerVM.date = new Date().toJSON();
                customerVM.loading=false;
    // customerVM.gridData = {};//resolvedData.locations.data;
                customerVM.phoneNumberFields=[];
                customerVM.addPhoneField();
                customerVM.isEdit = false;
    // customerVM.designationsLookup = resolvedData.Designations.data;
    // customerVM.usersLookup = resolvedData.Users.data;
    // customerVM.Devices = resolvedData.Devices.data;
                customerVM.endmindate = angular.copy(customerVM.date);

                customerVM.StartDateInvalid = false;
                customerVM.EndDateInvalid = false;
//////////////////////////DATE TIME PICKER CONFIGURATIONS/////////////////////
                customerVM.currentdateObj = new Date();
                customerVM.date = customerVM.currentdateObj.toJSON();

    //customerVM.minEnddate = angular.copy(customerVM.date);
                customerVM.StartDateReadonly = customerVM.isEdit;
                customerVM.EndDateReadonly = false;

                if (angular.isDefined(resolvedData.Customer.data)) {
                    customerVM.isEdit=true;
                    customerVM.vm = resolvedData.Customer.data;
                    customerVM.minEndDate = customerVM.vm.EffectiveStartDate;
      // customerVM.vm.LocationName = customerVM.getLocationName(customerVM.gridData,customerVM.vm.LocationId);
                }
                else {
                    customerVM.vm = resolvedData.Customer;
                    customerVM.StartDateReadonly = false;
                    customerVM.vm.EffectiveStartDate = customerVM.date;
            //define minimum emd date
                    customerVM.minEndDate = customerVM.vm.EffectiveStartDate;
                }
    // customerVM.minDate = customerVM.StartDateString;
                customerVM.readonly = false;
    // customerVM.StartDateReadonly = false;
    // customerVM.EndDateReadonly = false;
                customerVM.showStatus = true;
                if (customerVM.vm.EffectiveEndDate < customerVM.date) 
                    customerVM.vm.status = "inactive";
                else if (angular.isDefined(customerVM.vm.TmxUserDevice)) 
                    customerVM.vm.status = "active";
    // if(angular.isDefined(customerVM.vm.TmxUserDevice.UserId))
                customerVM.lookup = {};

                lookupService.getGender().then(function(types) {
      // types.forEach(function(type) {
        // type.HiddenValue = type.LookupId;
      // });
                    customerVM.lookup.gender = types;
                });

                lookupService.getMaritalStatus().then(function(types) {
                    customerVM.lookup.maritalStatus = types;
                });

                lookupService.getProfession().then(function(types) {
                    customerVM.lookup.profession = types;
                });

                lookupService.getTrainings().then(function(types) {
                    customerVM.lookup.trainings = types;
                });
                lookupService.getResidence().then(function(types) {
                    customerVM.lookup.residence = types;
                });
                lookupService.getEducation().then(function(types) {
                    customerVM.lookup.education = types;
                });
                lookupService.getRelationships().then(function(types){
                    customerVM.lookup.relationships=types;
                });
                lookupService.getAddressType().then(function(types){
                    customerVM.lookup.addresstype=types;
                });
                customerVM.getDisability=function(){
                    if(angular.isDefined(customerVM.vm.TmxCustomerHousehold) && customerVM.vm.TmxCustomerHousehold.length>0) {
                        if(angular.isDefined(customerVM.vm.TmxCustomerHousehold[0].DisabilityFlag))
                            return customerVM.vm.TmxCustomerHousehold[0].DisabilityFlag;
                    }
      
                }
                customerVM.disabilityChanged=function(newA){
                    if(newA==1){
                        customerVM.disableDisabilityField = false;
                    }
                    else
                        customerVM.disableDisabilityField = true;
                }
                customerVM.getTrainings=function(){
                    if(angular.isDefined(customerVM.vm.TmxCustomerHousehold) && customerVM.vm.TmxCustomerHousehold.length>0) {
                        if(angular.isDefined(customerVM.vm.TmxCustomerHousehold[0].TechnicalVocationalTrainingTypeLkp))
                            return customerVM.vm.TmxCustomerHousehold[0].TechnicalVocationalTrainingTypeLkp;
                    }
                }
                customerVM.TrainingsChanged=function(newA){
                    if(newA==1){
                        customerVM.disableTrainingsField = false;
                    }
                    else
                        customerVM.disableTrainingsField = true;
                }
                $scope.$watch(customerVM.getDisability,customerVM.disabilityChanged);
                $scope.$watch(customerVM.getTrainings,customerVM.TrainingsChanged);
                customerVM.lookup.disability = [
                    {
                        HiddenValue: "0",
                        VisibleValue: "No",
                    }, 
                    {
                        HiddenValue: "1",
                        VisibleValue: "Yes",
                    }
                ];
                customerVM.lookup.status = [
                    {
                        HiddenValue: "active",
                        VisibleValue: "Active",
                    }, 
                    {
                        HiddenValue: "inactive",
                        VisibleValue: "Inactive",
                    }
                ];
    // customerVM.lookup.users = resolvedData.Users.data;
                customerVM.currentStatus = customerVM.getStatus();

    ////////////////////////////////////////////////////
            }]);
})();
